import { RootState } from "../../state";

export const selectWeek = (state: RootState) => state.week.value;
